<div>
  <div class="header">
    <myapp-header *ngIf="showHeader"></myapp-header>
  </div>

  <div class="content">
    <router-outlet></router-outlet>
  </div>

<p-confirmDialog></p-confirmDialog>
</div>
